<template>
  <div class="bm-setting-match" >
    <div class="title" >
      赛事报名
    </div>
    <div class="switch" v-if="signUpRule" >
      <van-cell-group>
        <van-cell title="是否接受报名" >
            <van-switch
              v-model="signUpRule.allowTeamSignUp"
              active-color="#32A377"
              size="24px"
              @change="changeMatch"
            ></van-switch>
        </van-cell>
        <van-cell title="是否展示赛事页报名入口" >
          <van-switch
            v-model="signUpRule.publicSignUp"
            active-color="#32A377"
            size="24px"
            @change="changeSignUp"
            :disabled="!signUpRule.allowTeamSignUp"
          ></van-switch>
        </van-cell>
        <van-cell title="是否禁止修改球员资料" >
          <van-switch
            v-model="signUpRule.disableFreePlayerData"
            active-color="#32A377"
            size="24px"
            @change="changeFreePlayer"
          ></van-switch>
      </van-cell>
      </van-cell-group>
    </div>
    <div class="number" >
      <van-cell-group>
        <van-cell title="球队人数上限" is-link :value="signUpRule.teamMemberLimitCount" @click="isShowPopup('teamMemberLimitCount')" ></van-cell>
        <van-cell title="报名费用" is-link :value="signUpRule.entryFee" @click="isShowPopup('entryFee')" ></van-cell>
        <van-cell title="保证金" is-link :value="signUpRule.deposit" @click="isShowPopup('deposit')" ></van-cell>
        <van-cell title="报名截止日" is-link :value="signUpRule.regEndDate" @click="isShowPopupTime= true" ></van-cell>
        <div style="width: 100%; height: 15px;" ></div>
        <van-cell class="player" title="设置球队入赛规则" is-link @click="goTeamPlayerRulesPage" />
      </van-cell-group>
    </div>
    <!--<div class="player" >
      <van-cell-group>
      </van-cell-group>
    </div>-->
    <div class="btn" >
      <van-button type="primary" size="large" @click="setMatchRule(1)" >确认</van-button>
    </div>

    <van-popup v-model="popupShow" position="right" class="popup" >
      <div style="width: 100%; height: 30px;" ></div>
      <van-row class="form" type="flex" justify="space-between" >
        <van-col span="18" >
          <van-cell-group>
            <van-field v-model="value" placeholder="请输入..." />
          </van-cell-group>
        </van-col>
        <van-col span="5" align="right" >
          <van-button type="primary" @click="setValue" >确认</van-button>
        </van-col>
      </van-row>
    </van-popup>
    <van-popup
      v-model="isShowPopupTime"
      position="bottom">
      <van-datetime-picker
        @cancel="cancelDate"
        @confirm="confirmDate"
        v-model="date"
        :min-date="minDate"
        type="date">
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Switch, Button, Toast, DatetimePicker } from 'vant'
import { getBMMatchSignUpRule, updateBMMatchSignUpRule } from '@/api/team'
import Moment from 'moment'
Vue.use(Switch).use(Button).use(Toast).use(DatetimePicker)
export default {
  name: 'settingMatch',
  data() {
    return {
      popupShow: false,
      isShowPopupTime: false,
      value: null,
      signUpRule: {},
      query: this.$route.query,
      matchId: null,
      varName: null,
      date: null,
      minDate: new Date()
    }
  },
  created() {
    this.matchId = this.query.matchId
    if (!this.matchId) {
      Toast('参数错误')
      return
    }
    this.getBMMatchSignUpRule()
  },
  computed: {},
  methods: {
    getBMMatchSignUpRule() {
      getBMMatchSignUpRule({ matchId: this.matchId }).then((response) => {
        this.signUpRule = response.data.signUpRule
        if (this.signUpRule.allowTeamSignUp === 1) {
          this.signUpRule.allowTeamSignUp = true
        } else {
          this.signUpRule.allowTeamSignUp = false
        }

        if (this.signUpRule.publicSignUp === 1) {
          this.signUpRule.publicSignUp = true
        } else {
          this.signUpRule.publicSignUp = false
        }
        if (this.signUpRule.disableFreePlayerData === 1) {
          this.signUpRule.disableFreePlayerData = true
        } else {
          this.signUpRule.disableFreePlayerData = false
        }
        if (this.signUpRule.regEndDate) {
          // this.date = Moment.utc(this.signUpRule.regEndDate).toDate()
          this.formatterTime(this.signUpRule.regEndDate)
        }
      })
    },
    formatterTime(date) {
      this.signUpRule.regEndDate = Moment(date).format('YYYY.MM.DD')
      this.date = Moment.utc(date).toDate()
    },
    isShowPopup(obj) {
      this.varName = obj
      this.value = this.signUpRule[this.varName]
      this.popupShow = true
    },
    setValue() {
      this.signUpRule[this.varName] = this.value
      this.popupShow = false
      this.setMatchRule()
    },
    cancelDate() {
      this.isShowPopupTime = false
    },
    confirmDate(date) {
      this.isShowPopupTime = false
      this.formatterTime(date)
      this.setMatchRule()
    },
    changeMatch(value) {
      if (!value) {
        this.signUpRule.publicSignUp = false
      }
      this.setMatchRule()
    },
    changeSignUp() {
      this.setMatchRule()
    },
    changeFreePlayer() {
      this.setMatchRule()
    },
    goTeamPlayerRulesPage () {
      this.$router.push({ name: 'SettingPlayer', query: {matchId: this.matchId} })
    },
    setMatchRule(name) {
      let params = {
        matchId: this.matchId,
        allowTeamSignup: this.signUpRule.allowTeamSignUp ? 1 : 0,
        publicSignUp: this.signUpRule.publicSignUp ? 1 : 0,
        disableFreePlayerData: this.signUpRule.disableFreePlayerData ? 1 : 0,
        deposit: this.signUpRule.deposit,
        entryFee: this.signUpRule.entryFee,
        teamMemberLimitCount: this.signUpRule.teamMemberLimitCount,
        regEndDate: this.date
      }
      updateBMMatchSignUpRule(params).then((response) => {
        if (response) {
          if (name) {
            Toast('更新成功')
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" >
.bm-setting-match
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .van-hairline--top-bottom::after
    border-width 0
  .van-hairline--top-bottom
    ::after
      border-width 0px
  .van-cell-group
    .van-cell
      font-weight:300;
      color: rgba(74,74,74,1);
      font-size: 16px
      background-color white !important
    .van-icon
      color: black
    .van-cell__title
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      width: 80%
      flex: 2
  .number
    .van-cell-group
      .van-cell
        font-size: 14px;
        position relative
       .van-cell::before
         content ""
         position absolute
         height: 1px
         width calc(100% - 30px)
         background-color #E6E6E6
         bottom: 0
       .van-cell:last-child::before
          background-color transparent
  .player
    .van-cell__title
      color: #000000
      font-weight:500;
      font-size:18px
  .btn
    position absolute
    bottom 15px
    left 50%
    transform translate(-50%, 0)
    padding: 0 40px
    width: calc(100% - 80px)
    background-color white
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color:rgba(50,163,119,1);
      line-height:25px;
      border-radius 4px
    .van-button--primary
      background-color #32A377
      font-size:16px;
      font-weight:400;
      color:rgba(255,255,255,1);
  .popup
    width 100%
    height: 100%
    background-color white
    .van-cell
      border: 1px solid #E6E6E6
    .van-button
      background-color #32A377
    .form
      padding: 0 15px;
</style>



// WEBPACK FOOTER //
// src/pages/team/setting/match.vue